import {call, put} from 'redux-saga/effects';
import {receiveFormsData} from "../actions/formsActions";
import {fetchFormsData} from "../api/fetchFormsData";

export default function* getFormsData(action) {
  try {
    const formsData = yield call(fetchFormsData);
    yield put(receiveFormsData(formsData));
  } catch (e) {
    console.log(e)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/formsSaga.js